// Campus photo for /colleges/rutgers-university-new-brunswick: CC BY 4.0, by ajay_suresh, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AOld_Queens_-_Rutgers_University_(55142886116).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/rutgers-university-new-brunswick/; credited under the photo.
const photo = {
    "slug": "rutgers-university-new-brunswick",
    "alt": "Old Queens, a brownstone building with a white cupola, behind a lawn at Rutgers University-New Brunswick",
    "src": "/colleges/rutgers-university-new-brunswick/campus-1600.webp",
    "srcSmall": "/colleges/rutgers-university-new-brunswick/campus-800.webp",
    "srcMid": "/colleges/rutgers-university-new-brunswick/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/rutgers-university-new-brunswick/og.jpg",
    "title": "Old Queens - Rutgers University (55142886116)",
    "author": "ajay_suresh",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AOld_Queens_-_Rutgers_University_(55142886116).jpg",
    "read": "2026-10-02"
};

export default photo;
